/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates what should occur on a header click event.
 */
export var HeaderClickAction = /*@__PURE__*/ (function (HeaderClickAction) {
    /**
     * Sorting by one column is permitted and toggles between ascending and descending.
     */
    HeaderClickAction[HeaderClickAction["SortByOneColumnOnly"] = 0] = "SortByOneColumnOnly";
    /**
     * Sorting by multiple columns is permitted and each toggle between ascending and descending.
     */
    HeaderClickAction[HeaderClickAction["SortByMultipleColumns"] = 1] = "SortByMultipleColumns";
    /**
     * Sorting by one column is permitted and toggles between ascending, descending and unsorted.
     */
    HeaderClickAction[HeaderClickAction["SortByOneColumnOnlyTriState"] = 2] = "SortByOneColumnOnlyTriState";
    /**
     * Sorting by multiple columns is permitted and toggles between ascending, descending and unsorted.
     */
    HeaderClickAction[HeaderClickAction["SortByMultipleColumnsTriState"] = 3] = "SortByMultipleColumnsTriState";
    /**
     * No action is triggered.
     */
    HeaderClickAction[HeaderClickAction["None"] = 4] = "None";
    return HeaderClickAction;
})({});
/**
 * @hidden
 */
export var HeaderClickAction_$type = /*@__PURE__*/ markEnum('HeaderClickAction', 'SortByOneColumnOnly,0|SortByMultipleColumns,1|SortByOneColumnOnlyTriState,2|SortByMultipleColumnsTriState,3|None,4');
//# sourceMappingURL=HeaderClickAction.js.map
